import React, { Component } from 'react';
import PropTypes from "prop-types";


class  XImg extends Component{

    constructor(props) {
        super(props);
        this.onLoad=this.props.onLoad;
        this.src=this.props.src;
        this.state = {render:false};
        this.props=props;
    }

    setSrc(src){
        this.src=src;
    }

    setOnLoad(l){
        this.onLoad=l;
    }

    clearOnLoad(){
        this.onLoad=null;
    }

    refresh(){
        let r=!this.state.render;
        this.setState({render:r})  ;
    }


    render(){
        const {
            className,
            id,
            eleRef,
            onClick,
            attrs,
            crossOrigin,
            alt
        } = this.props;

        return <img alt={alt}  crossOrigin={crossOrigin} ref={eleRef} className={className} id={id} src={this.src} onLoad={this.onLoad}  onClick={onClick}  {...attrs}     />;
    }
}

XImg.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    src: PropTypes.string,
    eleRef: PropTypes.any,
    onClick: PropTypes.func,
    onLoad: PropTypes.func,
    attrs: PropTypes.object,
    crossOrigin: PropTypes.string,
    alt:PropTypes.string,
};

XImg.defaultProps = {
    attrs:{},
    alt:""
};

export default  XImg;
